// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1TtKj","navDetail":"App_navDetail__3Y9Vu"};